import { jsx as _jsx } from "react/jsx-runtime";
import React from "../../react";
import SharedComponents from "../SharedComponents";
const Spread = ({ props, children }) => {
    return React.cloneElement(children, { ...props });
};
const Link = (props) => {
    if (props.target === "product") {
        return _jsx(ProductLink, { ...props });
    }
    if (props.target === "category") {
        return _jsx(CategoryLink, { ...props });
    }
    return _jsx(SimpleLink, { ...props });
};
const SimpleLink = ({ children, ...props }) => (_jsx("a", { ...props, children: children }));
const ProductLink = ({ productId, variantId, categoryId, href, children, target, ...props }) => {
    const { renderProductLink } = SharedComponents.useContext();
    if (typeof renderProductLink === "function") {
        return _jsx(Spread, { props: props, children: renderProductLink({ productId, variantId, categoryId, href, children, target }) });
    }
    return _jsx(SimpleLink, { href: href, target: "_top", ...props, children: children });
};
const CategoryLink = ({ categoryId, href, children, target, ...props }) => {
    const { renderCategoryLink } = SharedComponents.useContext();
    if (typeof renderCategoryLink === "function") {
        return _jsx(Spread, { props: props, children: renderCategoryLink({ categoryId, href, children, target }) });
    }
    return _jsx(SimpleLink, { href: href, target: "_top", ...props, children: children });
};
export default Link;
